import { Outlet } from 'react-router-dom';

import { values } from 'lodash-es';

import { MainLayoutBase } from '@/layout/mainLayout/MainLayoutBase';
import Header from '@/layout/mainLayout/header';
import type { LookoRouteObject } from '@/router/LookoRouteObject';

/**
 * 레이아웃을 제외한 카페24 라우터
 */
export const 카페24_상품_분류_연결_라우터 = {
  카페24_상품_분류_연결_페이지: {
    path: '/settings/market-linkage/cafe24/category/edit',
    async lazy() {
      const { default: Page } = await import('@/router/linkage/setting/cafe24/카페24_상품_분류_연결_페이지');
      return {
        Component: Page,
      };
    },
    handle: {
      title: '상품 분류 연결',
      hideSidebar: true,
    },
  } satisfies LookoRouteObject,
};

export const 카페24_상품_분류_연결_루트: LookoRouteObject = {
  path: '/',
  element: (
    <MainLayoutBase appBar={<Header />}>
      <Outlet />
    </MainLayoutBase>
  ),
  children: values(카페24_상품_분류_연결_라우터),
};
